import { Particles, DashLine, SocialContact } from '../components';
import { Head_1 } from '../components/Typography';
import '../animation/zoomInDown.css';
import styled from 'styled-components';
const Hero = () => {
  return (
    <HeroContainer className="hero-container">
      <Particles />
      <PresentMe>
        <HeadStyle className="animate__zoomInDown">Hi, I &apos; m Elham</HeadStyle>
        <NameDyn className="name-dyn">
          <DashLine />
          <NameDynSpan dataText="Creative Technologist">Creative Technologist</NameDynSpan>
          <DashLine />
          {/* <NameDynSpan>Full-Stack Developer</NameDynSpan>
          <NameDynSpan>ReactJS Geek</NameDynSpan> */}
        </NameDyn>
        <SocialContact />
      </PresentMe>
    </HeroContainer>
  );
};

export default Hero;

// factor
const HeadStyle = styled(Head_1)`
  @keyframes zoomInDown {
    0% {
      opacity: 0;
      transform: scale(0.5) translateY(-60px);
    }
    60% {
      opacity: 1;
      transform: scale(1.1) translateY(-20px);
    }
    100% {
      transform: scale(1) translateY(0);
    }
  }
  animation: zoomInDown 1s;
`;
const HeroContainer = styled.div`
  min-height: 100vh;
  background: #000000;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;
const PresentMe = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;
const NameDyn = styled.div`
  padding: 1rem 0;
  margin: 1.5rem 0;
`;
const NameDynSpan = styled.span`
  font-size: 1.5rem;
  font-weight: 700;
  color: #fff;
  margin: 0.5rem;
  display: block;
  font-size: 3.7rem;
  position: relative;
  letter-spacing: 0.5px;
  &:before {
    content: ${(props) => props.dataText};
    position:absoute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-right: 1px solid #fff;
    white-space: nowrap;
    overflow: hidden;
    color: #fff;
    animaion : type 6s steps(1) infinite;

    @keyframes type {
      0% {
        width: 0;
      }
      70% {
        width: 100%;
      }
      90% {
        width: 100%;
      }
      100% {
        width: 0;
      }
    }
`;
